import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LocalStorageService } from '../../services/ecommerce/localstorage.service';
import { jwtDecode } from 'jwt-decode';
import { environment } from '../../../../environments/environment';
interface DecodedToken {
	exp: number; // tiempo de expiración en segundos desde UNIX epoch
	// puedes añadir más campos si tu token tiene más info
}

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private token: string | null = null;
	private tokenExpiration: number | null = null;
	private readonly TOKEN_EXPIRATION_TIME = 20 * 60 * 1000; // 20 minutos en milisegundos
	// private readonly AUTH_URL = 'https://www.movilbus.pe/backendEcommerce/Auth/Login';
	private localStorageService = inject(LocalStorageService);
	private readonly AUTH_URL = `${environment.AUTH_URL}`;
	private credentials = {
		username: `${environment.AUTHEcommerceUser}`,
		password: `${environment.AUTHEcommercePassword}`
	};
	// private readonly AUTH_URL = 'https://www.movilbus.pe/devbackEcoBus/Auth/Login';
	// private credentials = { username: 'lead', password: '12345' };

	constructor(private http: HttpClient) {}

	login(): Observable<any> {
		return this.http.post(this.AUTH_URL, this.credentials).pipe(
			tap((response: any) => {
				const token = response.jwt;
				const expiration = Date.now() + this.TOKEN_EXPIRATION_TIME;
				this.localStorageService.setItem('authToken', token);
				this.localStorageService.setItem('tokenExpiration', expiration.toString());
			})
		);
	}

	isTokenExpired(): boolean {
		const token: string = this.localStorageService.getItem('authToken');
		if (!token) return true;
		const decoded = jwtDecode<DecodedToken>(token);
		const ahora = Math.floor(Date.now() / 1000);
		return decoded.exp < ahora;
		// const expiration = this.localStorageService.getItem('tokenExpiration');
		// return !expiration || Date.now() > parseInt(expiration, 10);
	}

	getToken(): string | null {
		// if (this.isTokenExpired()) {
		// 	this.token = null;
		// 	return null;
		// }
		return this.localStorageService.getItem('authToken');
	}

	autoLogin(): Observable<any> {
		if (this.isTokenExpired()) {
			// const creds = this.getStoredCredentials();
			// if (!creds) return of(null);
			return this.login();
		}
		return of(this.getToken());
	}

	// autoLogin(credentials: any): Observable<any> {
	// 	if (this.isTokenExpired()) {
	// 		return this.login(credentials);
	// 	}
	// 	return of(this.getToken());
	// }
}
